import axios from 'axios';

export const getTrader = async (navigate) => {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/trader`, {
            withCredentials: true,
            validateStatus: () => true
        });
        if (!result.data.success && (result.data.error.code === 'NO_TOKEN' || result.data.error.code === 'INVALID_TOKEN')) {
            localStorage.removeItem('user');
            navigate('/login');
        }
        return result.data;
    } catch (_) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
};

export const putTrader = async ({ company, number, address, description, instaUrl, tiktokUrl, facebookUrl, website, location, navigate }) => {
    try {
        const result = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/trader`,
            { company, number, address, description, instaUrl, tiktokUrl, facebookUrl, website, location },
            { withCredentials: true, validateStatus: () => true}
        );
        if (!result.data.success && (result.data.error.code === 'NO_TOKEN' || result.data.error.code === 'INVALID_TOKEN')) {
            localStorage.removeItem('user');
            navigate('/login');
        }
        return result.data;
    } catch (error) {
        return {success: false, error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
};
